import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subscription } from "rxjs";
//import { documentFile } from '../models/document.model';
import { map } from "rxjs/operators";
import { Subject, throwError } from "rxjs";
import { Router } from "@angular/router";
import { userDetails } from "src/app/models/user.model";
import { UserDetailService } from "./user-details.service";
import { environment } from "../environments/environment";
import { blogDetails } from "src/app/models/blog.model";

const BACKEND_URL = environment.apiUrl + "/blog";

@Injectable({
  providedIn: "root",
})
export class BlogService {
  //private documents: documentFile[] = [];
  blogDetails: blogDetails[];
  userDetails: userDetails[];
  blogDetail: any;
  userDetail: any;
  constructor(private http: HttpClient, private router: Router) {}
  userId = localStorage.getItem("userId");

  // uploadBlog(title: string, content: string, blogImagepath: File) {
  //   // console.log(title);
  //   // console.log(content);
  //   const userId = localStorage.getItem("userId");
  //   const blogDetails = {
  //     title: title,
  //     content: content,
  //     userId: userId,
  //     blogImagepath: blogImagepath,
  //   };
  //   this.http.post(BACKEND_URL + "/new-blog/", blogDetails).subscribe((res) => {
  //     console.log(res);
  //   });
  // }

  getBlogDetails() {
    return this.http.get<{
      _id: string;
      title: string;
      content: string;
      password: string;
      date: string;
      creator: string;
      blogImagepath: string;
      agentMLS_ID: string;
    }>(BACKEND_URL + "/all-blog/");
  }

  getAgentBlog(userid: string) {
    // const userId = localStorage.getItem("userId");
    const URL = BACKEND_URL + "/all-blog/" + userid;
    return this.http.get(URL);
  }

  getSingleBlog(blogId: string) {
    const URL = BACKEND_URL + "/single-blog/" + blogId;
    return this.http.get(URL);
  }

  getauthordetails(userid: string) {
    const URL = BACKEND_URL + "/user/" + userid;
    return this.http.get(URL);
  }

  getAllBlogs() {
    const URL = BACKEND_URL + "/all-blog/";
    return this.http.get(URL);
  }
}
